// ─── PLACEHOLDER PAYLOADS ────────────────────────────────────────────────────
// Some backend routes answer an upstream failure with stand-in rows instead of
// an error, flagged either on the envelope ({ _source: "representative" }) or
// per row ({ source: "representative" }). Those rows are not data: they must
// never render, reach the signal bus, the AI context or saved history.
// ⚠⚠ A stand-in row is treated exactly like a failed request — the caller shows
// its unavailable state. Never substitute a local copy in its place.

const isFlagged = (v) => String(v ?? "").toLowerCase() === "representative";

// The row list of a payload: a bare array or { data: [...] }.
export function payloadRows(payload) {
  if (Array.isArray(payload)) return payload;
  return Array.isArray(payload?.data) ? payload.data : [];
}

export function isPlaceholder(payload) {
  if (payload && !Array.isArray(payload) && isFlagged(payload._source)) return true;
  return payloadRows(payload).some((r) => r && typeof r === "object" && isFlagged(r.source));
}

// The payload's rows when they are real, else [].
export function liveRows(payload) {
  return isPlaceholder(payload) ? [] : payloadRows(payload);
}
